import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-800 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-palette-line text-2xl text-accent-400"></i>
                </span>
                <span className="font-display text-lg text-white">好色精灵探访记</span>
              </div>
              <p className="text-sm text-foreground-200 leading-relaxed">
                奇幻色彩冒险互动体验故事，跟随精灵穿越缤纷世界，感受色彩的力量与魔法。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">精灵世界</h4>
              <ul className="space-y-2">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-200 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">探索更多</h4>
              <ul className="space-y-2">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-200 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">关于我们</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    品牌故事
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    联系我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/"
                    className="text-sm text-foreground-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    最新篇章
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-700/30 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-300">
              &copy; {currentYear} 好色精灵探访记 版权所有
            </p>
            <div className="flex items-center gap-5">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 text-foreground-200 hover:bg-accent-500 hover:text-white transition-all cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 text-foreground-200 hover:bg-accent-500 hover:text-white transition-all cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 text-foreground-200 hover:bg-accent-500 hover:text-white transition-all cursor-pointer"
                aria-label="哔哩哔哩"
                rel="nofollow"
              >
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}